import { useSelector } from 'react-redux';
import { isAuthenticated as selector } from 'shared/selectors/app';

export const useAuthenticationStatus = () => {
  const { isAuthenticated } = useSelector(selector);
  return isAuthenticated;
};
